import YoutubeFeedTemplateApp from './vue/YoutubeTemplate.vue';

new Vue({
    el: "#youtube-feed-app",
    name: 'Meet the Makers',
    render: h => h(YoutubeFeedTemplateApp),
})



// WEBPACK FOOTER //
// ./scripts/youtubefeedtemplate.js